// Visual tokens copied from the Figma "TME_New-Transaction" dashboard card design.
// TODO: swap for @jll/jll.capability.designsystem.foundations tokens once that
// package publishes the matching surface/rag and text/rag variables.

export const CARD_BG = "#ffffff";
export const CARD_BG_HOVER = "#f6f9fa";
export const CARD_TEXT = "#01151d";
export const CARD_TEXT_SUBDUED = "#56656b";
export const CARD_BORDER = "#dfe5e8";
export const METRIC_BORDER = "#ced5d8";
export const FIELD_BG = "rgba(29, 104, 129, 0.04)";
export const FIELD_PLACEHOLDER = "#637177";
export const TOGGLE_TRACK_BG = "#f6f9fa";

export const BADGE_STYLES = {
  atRisk: {
    label: "At risk",
    background: "rgba(255, 26, 83, 0.05)",
    color: "#8c0f2e",
    hoverBackground: "#b0133a",
    hoverColor: "#ffffff",
  },
  onHold: {
    label: "On hold",
    background: "rgba(255, 97, 5, 0.05)",
    color: "#9c3901",
    hoverBackground: "#c14701",
    hoverColor: "#ffffff",
  },
};
